import { ILogisticServiceHistory, TLogisticServiceStatusName } from '../../../../../types/suscription/history.types';
import { LogisticServiceHistoryStepper } from './components/LogisticServiceHistoryStepper';

import './LogisticServiceDetailsTab4History.scss';

interface ILogisticServiceDetailsTab4HistoryProps {
  logisticServiceHistoryData: ILogisticServiceHistory[];
  logisticServiceStatusName: TLogisticServiceStatusName;
}

const LogisticServiceDetailsTab4History = ({
  logisticServiceHistoryData,
  logisticServiceStatusName
}: ILogisticServiceDetailsTab4HistoryProps) => {
  const renderSteps = () => {
    if (!logisticServiceHistoryData?.length) {
      return <p className="emptyStateText">No hay historial disponible para este servicio logístico</p>;
    }

    return (
      <LogisticServiceHistoryStepper
        logisticServiceHistory={logisticServiceHistoryData}
        logisticServiceStatusName={logisticServiceStatusName}
      />
    );
  };

  return (
    <div className="logisticServiceDetailsTab4History">
      <h2 className="title">Historial del servicio</h2>
      <div className="boxDetails">{renderSteps()}</div>
    </div>
  );
};

export default LogisticServiceDetailsTab4History;
